import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Gets the fallback value for work days option in calendar appearance settings
 */
export default (function () { return getFallbackValueIfNull(store().workDays, getCalendarConfiguration().WorkDays); });
//# sourceMappingURL=getWorkDays.js.map